module.exports = __webpack_public_path__ + "img/roof_types.8ecd5527.png";